<template>
  <div id="app" class="todo-container">
    <img alt="Vue logo" src="./assets/logo.png" class="logo">
    <TodoList/>
  </div>
</template>

<script>
import TodoList from './components/TodoList.vue'

export default {
  name: 'App',
  components: {
    TodoList,
  }
}
</script>

<style>
.todo-container{
  max-width: 700px;
  width: 90%;
  margin: 0 auto;
}

.logo {
  display: block;
  margin: 20px auto;
  height: 75px;
}
</style>
